import IEquatable from "./types/IEquatable";

const _primitiveValue: Symbol = Symbol("Success");

export default class Success implements IEquatable<Success> {
	static [Symbol.hasInstance](instance: any): boolean {
		return instance != null && instance.valueOf() === _primitiveValue;
	}

	/**
	 * Determines whether the specified value represents the same Success marker as this instance.
	 * Any value that coerces to the shared Success primitive (another Success instance) is considered equal.
	 * @param other The value to compare to this instance.
	 * @returns true if the specified value is a Success marker; otherwise, false.
	 */
	equals(other: Success | null | undefined): boolean {
		return other != null && other.valueOf() === _primitiveValue;
	}

	valueOf(): any {
		return _primitiveValue;
	}

	[Symbol.toPrimitive](): any {
		return _primitiveValue;
	}
}
